var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isServiceProviderCatalogOccupationsLoaded)?_c('sliding-tabs',{staticClass:"OCCUPATION-TABS",attrs:{"activeTab":_vm.serviceProviderOccupationName}},[_vm._l((_vm.tabOccupations),function({ id, occupationName }){return [(occupationName)?_c('sliding-tabs-content',{key:occupationName,attrs:{"name":occupationName,"active":occupationName === _vm.serviceProviderOccupationName,"titleProps":{
          title: occupationName,
          to: {
            name: occupationName === _vm.reviewsTitle
              ? 'pro-public-profile::reviews'
              : 'pro-public-profile',
            params: { serviceProviderOccupationId: id }
          },
        }}}):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }